import { createAction, props } from '@ngrx/store';
import { ILinkedBusinessesRequest } from '../models/linked-businesses.model';

export const loadAssetManagerViewLinkedBusinesses = createAction(
  '[AssetManagerViewLinkedBusinesses] Load AssetManagerViewLinkedBusinesses',
  props<{ request: ILinkedBusinessesRequest }>()
);

export const loadAssetManagerViewLinkedBusinessesSuccess = createAction(
  '[AssetManagerViewLinkedBusinesses] Load AssetManagerViewLinkedBusinesses Success',
  props<{ response: any }>()
);

export const loadAssetManagerViewLinkedBusinessesFailure = createAction(
  '[AssetManagerViewLinkedBusinesses] Load AssetManagerViewLinkedBusinesses Failure',
  props<{ error: Error | any }>()
);

export const clearAssetManagerViewLinkedBusinesses = createAction(
  '[Clear AssetManagerViewLinkedBusinesses] Clear AssetManagerViewLinkedBusinesses'
);
